var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMPlatnosci = function SvgMPlatnosci(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st5{fill:#ffffff;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M17.1,1H2.9C1.3,1,0,2.3,0,3.9s1.3,2.9,2.9,2.9V5C2.3,5,1.8,4.5,1.8,3.9s0.5-1.1,1.1-1.1h13.3v3H18V1.9 C18,1.4,17.6,1,17.1,1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M23.1,5H2.9C2.3,5,1.8,4.5,1.8,3.9C1.8,3.4,1.4,3,0.9,3S0,3.4,0,3.9v16.2C0,21.7,1.3,23,2.9,23h20.2 c0.5,0,0.9-0.4,0.9-0.9V5.9C24,5.4,23.6,5,23.1,5z M22.2,21.2H2.9c-0.6,0-1.1-0.5-1.1-1.1V6.6c0.3,0.1,0.7,0.2,1.1,0.2h19.3 L22.2,21.2L22.2,21.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M19,15.6c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h4v-1.8h-4c-1.8,0-3.3,1.5-3.3,3.3s1.5,3.3,3.3,3.3h4.1 v-1.8L19,15.6L19,15.6z"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMPlatnosci, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/m_platnosci.8f277eb4.svg";
export { ForwardRef as ReactComponent };